import * as React from 'react';
import { assignProps, createViewConfig } from '@sail/engine';
import { useFieldContexts } from '../hooks/useFieldContexts';
export const InputConfig = createViewConfig({
    props: {},
    name: 'Input',
    flattens: true,
    defaults: {
        as: 'input'
    }
});
function usePreventWheelInteractionProps(props) {
    const { type, onFocus, onBlur } = props;
    return React.useMemo(()=>{
        if (type === 'number') {
            const handler = (event)=>{
                const target = event.target;
                target.blur();
                const activeElementAfterBlur = document.activeElement;
                setTimeout(()=>{
                    if (document.activeElement === activeElementAfterBlur) {
                        // eslint-disable-next-line @sail/ui-no-reflow
                        target.focus();
                    }
                }, 0);
            };
            return {
                onFocus: (event)=>{
                    event.currentTarget.addEventListener('wheel', handler, {
                        passive: false
                    });
                    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
                },
                onBlur: (event)=>{
                    event.currentTarget.removeEventListener('wheel', handler);
                    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
                }
            };
        }
        return {};
    }, [
        type,
        onFocus,
        onBlur
    ]);
}
const NativeInput = createViewConfig({
    props: {},
    name: 'Input',
    flattens: true
}).createView((props)=>{
    const wheelProps = usePreventWheelInteractionProps(props);
    return /*#__PURE__*/ React.createElement("input", {
        ...props,
        ...wheelProps
    });
});
/**
 * Create interactive controls to accept data from users.
 */ export const Input = InputConfig.createGenericView(({ as, ...props })=>{
    const Element = as;
    if (as === 'input') {
        // @ts-expect-error Type fails in React 18
        return /*#__PURE__*/ React.createElement(NativeInput, props);
    }
    return /*#__PURE__*/ React.createElement(Element, props);
}, {
    uses: [
        assignProps((props)=>useFieldContexts(props))
    ]
});

//# sourceMappingURL=Input.js.map